import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'

export const trackShareBetLinkPlaced = (data: {
  amountPaid: number
  hasSpecialOffer: boolean
  legs: number
  raceCode: string | null
  origin: string
}) => {
  trackEvent(keys.shareBetLinkPlaced, data)
}

export const trackShareBetLinkOpen = ({ origin, betType }: { origin: string; betType: string }) => {
  trackEvent(keys.shareBetLinkOpen, { origin, betType })
}
